import { ICollapsedSetAction } from './types';
import { AT_COLLAPSED_SET } from './constants';

export const collapsedSet = (
    isCollapsed: boolean,
): ICollapsedSetAction => ({
        type: AT_COLLAPSED_SET,
        isCollapsed
    }
);
